<template>
    <FirstNavbarComponent />
    <SecondNavBarComponent />
    <PageHeader />
    <div class="page-content pt-0">
        <router-view name="sidebar" />
        <div class="content-wrapper">
            <div class="content">
                <router-view />
            </div>
        </div>
    </div>
    <WidgetPanel />
</template>
<script>
import FirstNavbarComponent from "./navbar/FirstNavBar/FirstNavBar.vue";
import PageHeader from "./navbar/PageHeader.vue";
import SecondNavBarComponent from "./navbar/SecondNavBar/SecondNavBar.vue";
import WidgetPanel from "./WidgetPanel.vue";
export default            {
    name: "ProjectLayout",
    components: {SecondNavBarComponent, PageHeader, FirstNavbarComponent, WidgetPanel},
}
</script>
